import CertificatePage from "./CertificatePage";

export default function CertificatePreviewModal({ cert, onClose }) {
  if (!cert) return null;

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.75)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 999, padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff", borderRadius: 16,
          width: "95vw", maxWidth: 1200,
          maxHeight: "95vh", overflowY: "auto",
          boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "sticky", top: 12, left: "100%",
            marginRight: 12, zIndex: 10,
            background: "#ff5421", color: "#fff",
            border: "none", borderRadius: 8,
            padding: "6px 14px", fontSize: 14,
            fontWeight: 700, cursor: "pointer",
            display: "block",
          }}
        >
          ✕ Close
        </button>

        {/* Actual certificate — fake searchParams inject karke */}
        <CertificateInjected cert={cert} />
      </div>
    </div>
  );
}

// CertificatePage searchParams use karta hai — hum usse bypass karke
// direct props se render karenge ek wrapper ke through
function CertificateInjected({ cert }) {
  // encryptUrl bypass — direct props pass karenge
  // CertificatePage ke andar plain params fallback hai (?name=&course= etc.)
  // hum usse ek hidden iframe ya direct render se use karenge

  // Seedha render — CertificatePage internally useSearchParams use karta hai
  // isliye hum URL params inject karte hain ek iframe mein
  const API_BASE = process.env.REACT_APP_API_URL || "http://187.127.165.240:5000";
  const FRONT    = window.location.origin;

  const params = new URLSearchParams({
    name:           cert.name           || "",
    course:         cert.course         || "",
    months:         cert.months         || "",
    completionDate: cert.completionDate || "",
    email:          cert.email          || "",
    verifyId:       cert.verifyId       || "",
  });

  const iframeUrl = `${FRONT}/certificate?${params.toString()}`;

  return (
    <iframe
      src={iframeUrl}
      style={{
        width: "100%",
        height: "85vh",
        border: "none",
        borderRadius: "0 0 16px 16px",
      }}
      title="Certificate Preview"
    />
  );
}